import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDownCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	height: 48,
	viewBox: "0 0 48 48",
	width: 48,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 24,
			cy: 24,
			fill: "#009fe3",
			r: 24
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#fff",
			transform: "translate(4 4)",
			children: [/* @__PURE__ */ _jsx("path", { d: "m20 39.25c-2.59906006 0-5.11997986-.50886154-7.49273968-1.51245117-2.29218006-.96950913-4.3509407-2.3576088-6.11906051-4.12574005-1.76812983-1.76812935-3.15622974-3.8268795-4.12574983-6.11906815-1.00358999-2.37275123-1.51244998-4.89368057-1.51244998-7.49274063s.50885999-5.11997986 1.51244998-7.49273968c.96952009-2.29218006 2.35762-4.35093021 4.12574983-6.11906051 1.7681303-1.76812983 3.82688045-3.15622974 6.11906051-4.12574983 2.37275982-1.00358999 4.89367962-1.51244998 7.49273968-1.51244998s5.1199894.50885999 7.49274063 1.51244998c2.29218865.96952009 4.3509388 2.35762 6.11906815 4.12574983 1.76813125 1.76811981 3.15623092 3.82688045 4.12574005 6.11906051 1.00358963 2.37275982 1.51245117 4.89367962 1.51245117 7.49273968 0 2.5990696-.50886154 5.1199894-1.51245117 7.49274063-.96950913 2.29218865-2.3576088 4.3509388-4.12574005 6.11906815-1.76812935 1.76813125-3.8268795 3.15623092-6.11906815 4.12574005-2.37275123 1.00358963-4.89367103 1.51245117-7.49274063 1.51245117z" }), /* @__PURE__ */ _jsx("path", {
				d: "m20 1.5c-4.94153023 0-9.58728981 1.92433929-13.08147812 5.41852188-3.49418259 3.49418831-5.41852188 8.13994789-5.41852188 13.08147812s1.92433929 9.58728981 5.41852188 13.08148193c3.49418831 3.49417878 8.13994789 5.41851807 13.08147812 5.41851807s9.58728981-1.92433929 13.08148193-5.41851807c3.49417878-3.49419212 5.41851807-8.1399517 5.41851807-13.08148193s-1.92433929-9.58728981-5.41851807-13.08147812c-3.49419212-3.49418259-8.1399517-5.41852188-13.08148193-5.41852188m0-1.5c11.04570007 0 20 8.95429993 20 20s-8.95429993 20-20 20-20-8.95429993-20-20 8.95429993-20 20-20z",
				fill: "#fff"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m1411.938 137.33 10 10 10-10",
			fill: "none",
			stroke: "#009fe3",
			strokeMiterlimit: 10,
			strokeWidth: 1.5,
			transform: "translate(-1397.938 -117.275)"
		})
	]
});
export default SvgChevronDownCircle;
